import { ReportFilterConfigBase } from "../../filters/config/types";

export const Filters: ReportFilterConfigBase[] = [
];
